import { styled } from '@linaria/react';

export const BookmakerClickOutContainer = styled.a<{
  isDisabled: boolean;
  show: boolean;
}>`
  display: ${props => (props.show ? 'contents' : 'none')};
  text-decoration: none;
  color: inherit;
  pointer-events: ${props => (props.isDisabled ? 'none' : 'auto')};
`;
